import axios from 'axios'
import {
  DailyResponse,
  DashboardParams,
  EventsResponse,
  FiltersResponse,
  HourlyResponse,
} from './types'
import type { T as Translate } from './i18n'

const BASE = '/profiles_dashboard'

const queryOf = (p: DashboardParams) => ({
  site: p.site,
  meter_type: p.meterType,
  start: p.start,
  end: p.end,
})

/**
 * Turns the API's `{messages: {error: [...]}}` (already in the user's language: the request carries
 * `lang`) or a network failure into one readable line.
 */
export function errorMessage(error: unknown, t: Translate): string {
  const response = (error as any)?.response
  const messages = response?.data?.messages
  if (messages && typeof messages === 'object') {
    const flat = Object.values(messages)
      .flat()
      .filter((m) => typeof m === 'string') as string[]
    if (flat.length) return flat.join(' ')
  }
  if (response?.status === 403) return t('PROFILES_DASHBOARD.ERROR.FORBIDDEN')
  if (response?.status === 404) return t('PROFILES_DASHBOARD.ERROR.NOT_FOUND')
  return t('PROFILES_DASHBOARD.ERROR.GENERIC')
}

async function get<T>(path: string, params: object | undefined, signal: AbortSignal): Promise<T> {
  const response = await axios.get(BASE + path, { params, signal })
  return response.data.data as T
}

export const fetchFilters = (signal: AbortSignal) =>
  get<FiltersResponse>('/filters', undefined, signal)
export const fetchDaily = (p: DashboardParams, signal: AbortSignal) =>
  get<DailyResponse>('/daily', queryOf(p), signal)
export const fetchEvents = (p: DashboardParams, signal: AbortSignal) =>
  get<EventsResponse>('/events', queryOf(p), signal)
export const fetchHourly = (p: DashboardParams, signal: AbortSignal) =>
  get<HourlyResponse>('/hourly', queryOf(p), signal)
